module.exports = __webpack_public_path__ + "img/add_b.8aad363a.svg";